import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-bold-heat',
  imports: [],
  templateUrl: './icon-bold-heat.component.html',
})
export class IconBoldHeatComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24';
}
